export class DynamicDetailsListItemRowData {
  constructor(public label: string, public value: string, public showInList: boolean = true, public useAsHeaderTitle: boolean = false) {}
}
